<template>
  <div class="content" ref="content">
    <div class="wrap">
      <div class="top_full">
        <template v-if="isFullscreen" >
          <a-icon v-if="!isTeachingMode" type="fullscreen-exit" class="icon" @click="toggleFullscreen(false)" />
          <a-icon v-else type="close" class="icon" @click="toggleFullscreen(false)" />
        </template>
        <a-icon type="fullscreen" class="icon" @click="toggleFullscreen(true)" v-else />
      </div>
      <div class="top_tit">
        <img :src="require(`@/assets/${this.$i18n.locale}/bi_tit.png`)" alt="" />
        <span v-if="!isTeachingMode" class="switch" @click="changePanelType"><a-icon type="swap"/></span>
      </div>
      <div class="main">
        <SynthesisData ref="synthesisData" v-if="panelType == 0" />
        <TeachingData ref="teachingData" v-else :contentRef="contentRef" />
      </div>
    </div>
    <!-- <div>Window Width: {{ windowWidth }}</div> -->
  </div>
</template>
<script>
import SynthesisData from './synthesisData.vue'
import TeachingData from './teachingData.vue'

export default {
  name: 'BiAnalysis',
  components: {
    SynthesisData,
    TeachingData
  },
  data() {
    return {
      contentRef: null,
      isFullscreen: false,
      isTeachingMode: false,
      panelType: 0 // 0 综合 1 教学
    }
  },
  methods: {
    changePanelType() {
      console.log('panelType', this.panelType)
      this.panelType = this.panelType === 0 ? 1 : 0
    },
    toggleFullscreen(status) {
      const content = this.$refs.content

      if (status) {
        this.enterFullscreen(content)
      } else {
        if (this.$route.name === 'teachingStats') { 
          this.$router.go(-1)
          return
        }
        this.exitFullscreen()
      }
    },
    enterFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen()
      }
      this.isFullscreen = true
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen()
      }
      this.isFullscreen = false
    },
    onFullscreenChange() {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )
      // this.getData()
      console.log('this.$refs ----->', this.$refs)
      if (this.$refs.synthesisData) this.$refs.synthesisData.getData()
      if (this.$refs.teachingData) this.$refs.teachingData.initChart()
    },
    handleEscPress() {
      // 处理ESC键被点击的逻辑
      console.log('ESC key pressed')
      this.toggleFullscreen(false)
    }
  },
  mounted() {
    if (this.$route.name === 'teachingStats') {
      this.isFullscreen = true
      this.isTeachingMode = true
      this.panelType = 1
    }
    this.$nextTick(() => {
      this.contentRef = this.$refs.content // 确保 ref 已渲染
    })
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
  }
}
</script>

<style scoped lang="less">
.content {
  background-image: url(~@/assets/img/bi_bj.png) !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden !important;
  padding: 0 27px 12px !important;
  .wrap {
    height: calc(100% - 101px);
    overflow-y: auto;
    margin-top: 101px;
    /deep/ .ant-select {
      height: 25px;
      line-height: 25px;
      .ant-select-selection--single {
        height: 25px;
        line-height: 25px;
        .ant-select-selection__rendered {
          line-height: 25px;
        }
      }
      .ant-select-selection__placeholder, .ant-select-search__field__placeholder {
        margin-top: -11.5px;
      }
    }
    /deep/ .ant-calendar-picker {
      height: 25px;
      line-height: 25px;
      .ant-calendar-picker-input {
        line-height: 17px;
        height: 25px;
      }
    }
  }
  .top_full {
    position: absolute;
    right: 50px;
    top: 28px;
    .icon {
      font-size: 20px;
    }
  }
  .top_tit {
    position: absolute;
    top: 4%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 46%;
    }
    .switch {
      color: #fff;
      padding-left: 10px;
      font-size: 16px;
      &:hover {
        color: #ffb641;
        cursor: pointer;
      }
    }
  }
}
.main {
  height: 100%;
}
/deep/ .ant-calendar-range-picker-input {
  width: 50% !important;
}
/deep/.ant-calendar-picker-input {
  display: flex;
  border-radius: 40px;
}
/deep/ .ant-select-selection--single {
  border-radius: 40px;
}
.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  z-index: 999;
}
.overflow {
  max-width: 70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen and (min-height: 960px) and (max-height: 1400px) {
  .content .main .main_left .main_left_top_msg {
    margin-top: calc(100% - 88%);
  }
  .main_right_top_content {
    margin-top: 15% !important;
  }
  .content .main .main_right .main_right_top .main_right_top_content_t {
    margin-top: 15% !important;
  }
}
</style>
